/** @jsxImportSource @emotion/react */
import { ROUTES } from '@sportninja/common/constants/app'
import { useMemo } from 'react'
import Page from '../../components/Page'
import MyScheduleList from './MyScheduleList'
import { MyScheduleContextProvider } from '../../context/MyScheduleContext'

/**
 * MySchedule page component
 * Displays the user's personal schedule
 */
const MySchedule = () => {
  const pages = useMemo(
    () => [
      {
        to: `${ROUTES.MY_SCHEDULE}/my`,
        component: <MyScheduleList />,
      },
    ],
    []
  )

  const BASE_ROUTE = ROUTES.MY_SCHEDULE

  return (
    <MyScheduleContextProvider>
      {/* @ts-ignore */}
      <Page
        baseRoute={BASE_ROUTE}
        // @ts-ignore
        pages={pages}
        baseTitle='Schedule'
        title='My Schedule'
        isOrgsPage={true}
        hideBreadcrumbs={true}
        displayMobileActions={false}
      />
    </MyScheduleContextProvider>
  )
}

export default MySchedule
